<template>
    <div v-if="mission" class="small">
        <h6 class="mb-2 d-flex align-items-center gap-2">
            Chauffeurs — Vérification
            <span v-if="mission.status !== 'DRAFT'" class="badge rounded-pill" :class="statusBadgeClass"
                :title="statusBadgeTitle">
                {{ statusBadgeText }}
            </span>
        </h6>

        <ul class="list-group mb-2">
            <li v-for="member in mission.members" :key="member.id" class="list-group-item">
                <div class="d-flex justify-content-between align-items-center">
                    <span class="text-break" :title="member.firstName + ' ' + member.lastName">
                        {{ member.firstName }} {{ member.lastName }}
                        <template v-if="!$isViewer && isVerifiedTwice && member.verificationCode">
                            <span class="mx-2 text-muted">•</span>
                            <span class="text-muted me-1">Mot de passe :</span>
                            <span class="font-monospace fw-semibold" style="letter-spacing:0.5px">{{
                                member.verificationCode }}</span>
                        </template>
                    </span>
                </div>

                <!-- Saisie du code uniquement en PENDING et tant que non vérifié -->
                <div v-if="showInputs" class="mt-2 d-flex align-items-center gap-2 flex-wrap">
                    <input type="password" class="form-control form-control-sm" style="max-width: 220px"
                        :placeholder="'Mot de passe...'" v-model="codes[member.id]" name="driver-verification-code"
                        autocomplete="one-time-code" autocapitalize="none" autocorrect="off" spellcheck="false" />
                    <button class="btn btn-sm btn-primary" @click="submitCode(member)"
                        :disabled="!codes[member.id] || !codes[member.id].trim()">
                        Vérifier
                    </button>
                </div>
            </li>
            <li v-if="!mission.members?.length" class="list-group-item text-muted">Aucun chauffeur affecté.</li>
        </ul>
    </div>
    <div v-else />
</template>

<script>
import MissionMemberService from '@/services/missionMember.service'

export default {
    name: 'MembersVerify',
    props: { mission: { type: Object, required: true }, forceShowInputs: { type: Boolean, default: false } },
    emits: ['refresh', 'setAlertCode'],
    data() {
        return { codes: {} };
    },
    computed: {
        hasMembers() {
            return Array.isArray(this.mission?.members) && this.mission.members.length > 0;
        },
        showInputs() {
            if (this.forceShowInputs) return true;
            return this.mission?.status === 'PENDING' && !this.$isViewer && !this.mission?.driverVerified;
        },
        isVerifiedOnce() {
            return this.mission?.verifiedInfo === 'ONCE';
        },
        isVerifiedTwice() {
            return this.mission?.verifiedInfo === 'TWICE';
        },
        statusBadgeClass() {
            if (!this.hasMembers) return 'bg-warning text-dark';
            return (this.isVerifiedTwice || this.isVerifiedOnce) && this.mission.status === 'PENDING'
                ? 'bg-success'
                : 'bg-warning text-dark';
        },
        statusBadgeText() {
            if (!this.hasMembers) return 'À sélectionner';
            if (this.isVerifiedTwice) return 'Vérifié 2/2';
            if (this.isVerifiedOnce) return 'Vérifié 1/2';
            return 'À vérifier';
        },
        statusBadgeTitle() {
            if (!this.hasMembers) {
                return 'Aucun chauffeur sélectionné. Ajoutez au moins un chauffeur avant le démarrage.';
            }
            if (this.isVerifiedTwice) {
                return 'Le chauffeur a été vérifié deux fois. Vous pouvez démarrer.';
            }
            if (this.isVerifiedOnce) {
                return 'Une vérification a été effectuée. Re-vérifiez le chauffeur avant le démarrage.';
            }
            return 'Le mot de passe du chauffeur doit être vérifié (2 fois) avant le démarrage.';
        }
    },
    methods: {
        submitCode(member) {
            if (!this.showInputs) return;
            const code = (this.codes[member.id] || '').trim();
            if (!code) return;
            MissionMemberService.verifyCode(this.mission.id, member.id, code)
                .then(({ data }) => {
                    if (data?.status === 'OK') {
                        this.$emit('refresh');
                    } else if (data?.status === 'ALERT') {
                        this.$emit('setAlertCode', true);
                    } else {
                        alert('Mot de passe invalide.');
                    }
                })
                .catch(() => alert('Erreur lors de la vérification.'))
                .finally(() => {
                    // vider le champ de saisie quelle que soit l'issue
                    this.codes[member.id] = '';
                });
        }
    }
}
</script>
